/* azado V2 (Okt. 2026): Beratung (Concierge), Grill-Finder, Kollektions-Reihe.
   Eigene Datei, damit V2 sauber entfernbar bleibt (siehe Kopf von azado-v2.css). */
(function () {
  "use strict";

  /* ---------- Beratung (Concierge) ---------- */
  function initConcierge() {
    var root = document.getElementById("az-concierge");
    if (!root) return;
    var panel = root.querySelector(".az-concierge__panel");
    var form = root.querySelector("form");
    var modeField = root.querySelector('[data-az-field="mode"]');
    var modelField = root.querySelector('[data-az-field="model"]');
    var body = form ? form.querySelector("textarea") : null;
    var lastFocus = null;

    function setMode(mode) {
      var msg = mode === "message";
      root.classList.toggle("is-message", msg);
      root.querySelectorAll(".az-concierge__modes button").forEach(function (b) {
        var on = b.getAttribute("data-mode") === (msg ? "message" : "visit");
        b.classList.toggle("is-active", on);
        b.setAttribute("aria-selected", on ? "true" : "false");
      });
      root.querySelectorAll("[data-label-visit]").forEach(function (el) { el.hidden = msg; });
      root.querySelectorAll("[data-label-message]").forEach(function (el) { el.hidden = !msg; });
      if (modeField) modeField.value = msg ? "Nachricht" : "Showroom-Termin";
      if (body) body.required = msg;
      /* Showroom-Termin: Datum + Uhrzeit Pflicht, im Nachrichten-Modus nicht */
      root.querySelectorAll("[data-az-visit-required]").forEach(function (el) { el.required = !msg; });
    }
    function open(mode, model) {
      lastFocus = document.activeElement;
      setMode(mode || "message");
      if (model && modelField) modelField.value = model;
      root.classList.add("is-open");
      root.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("az-locked");
      setTimeout(function () {
        var first = root.querySelector(".az-concierge__status") || root.querySelector('input[name="contact[name]"]');
        if (first && first.focus) first.focus({ preventScroll: true });
      }, 60);
    }
    function close() {
      root.classList.remove("is-open");
      root.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("az-locked");
      root.classList.remove("is-sent");
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      if (location.hash === "#termin" && history.replaceState) history.replaceState(null, "", location.pathname + location.search);
    }
    window.azadoConcierge = { open: open, close: close };

    document.addEventListener("click", function (e) {
      var t = e.target.closest && e.target.closest('[data-az-concierge], a[href="#termin"], a[href$="/#termin"]');
      if (!t) return;
      e.preventDefault();
      open(t.getAttribute("data-az-concierge") || "message", t.getAttribute("data-az-model"));
    });
    root.querySelectorAll("[data-az-concierge-close]").forEach(function (el) { el.addEventListener("click", close); });
    root.querySelectorAll(".az-concierge__modes button").forEach(function (b) {
      b.addEventListener("click", function () { setMode(b.getAttribute("data-mode")); });
    });
    document.addEventListener("keydown", function (e) {
      if (!root.classList.contains("is-open")) return;
      if (e.key === "Escape") close();
      if (e.key === "Tab") {
        var f = [].slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea'))
          .filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
    /* Okt. 2026: Showroom ist Sa und So zu. Native Datumsfelder koennen keine Wochentage sperren,
       deshalb sofort markieren und das Absenden blockieren (Zeiten Mo bis Fr 8 bis 17 Uhr bleiben). */
    var dateIn = form ? form.querySelector("[data-az-weekdays]") : null;
    var dateHint = form ? form.querySelector("[data-az-date-hint]") : null;
    function checkDate(report) {
      if (!dateIn) return true;
      var v = dateIn.value, bad = false;
      if (v && !root.classList.contains("is-message")) {
        var p = v.split("-"), wd = new Date(+p[0], +p[1] - 1, +p[2]).getDay();
        bad = wd === 0 || wd === 6;
      }
      dateIn.setCustomValidity(bad ? (dateIn.getAttribute("data-msg-weekend") || "Mo-Fr") : "");
      if (dateHint) dateHint.hidden = !bad;
      if (bad && report && dateIn.reportValidity) dateIn.reportValidity();
      return !bad;
    }
    if (dateIn) {
      dateIn.addEventListener("change", function () { checkDate(true); });
      dateIn.addEventListener("input", function () { checkDate(false); });
    }
    root.querySelectorAll(".az-concierge__modes button").forEach(function (b) { b.addEventListener("click", function () { checkDate(false); }); });
    if (form) {
      form.addEventListener("submit", function (e) {
        if (!checkDate(true)) { e.preventDefault(); return; }
        try {
          var g = function (n) { var el = form.querySelector('[name="contact[' + n + ']"]'); return el ? el.value : ""; };
          sessionStorage.setItem("azConciergeLast", JSON.stringify({ visit: g("Anliegen") === "Showroom-Termin", date: g("Wunschdatum"), time: g("Uhrzeit") }));
        } catch (err) {}
      });
    }
    /* Nach dem Absenden lädt Shopify die Seite mit #AzConcierge neu: Dialog mit Bestätigung zeigen,
       beim Showroom-Termin im Termin-Reiter mit Datum und Uhrzeit, ohne leeres Formular darunter. */
    var status = root.querySelector("[data-az-concierge-status]");
    if (location.hash === "#AzConcierge" && status) {
      var last = null;
      try { last = JSON.parse(sessionStorage.getItem("azConciergeLast") || "null"); sessionStorage.removeItem("azConciergeLast"); } catch (err) {}
      var ok = status.classList.contains("az-concierge__status--ok");
      open(last && last.visit ? "visit" : "message");
      if (ok) {
        root.classList.add("is-sent");
        var tpl = status.getAttribute("data-visit-ok");
        if (last && last.visit && last.date && tpl) {
          var dp = last.date.split("-");
          var ds = new Date(+dp[0], +dp[1] - 1, +dp[2]).toLocaleDateString(document.documentElement.lang || "de-CH", { weekday: "short", day: "numeric", month: "numeric", year: "numeric" });
          status.textContent = tpl.replace("{date}", ds).replace("{time}", last.time || "");
        }
      }
    }
    if (location.hash === "#termin") open("visit");
    window.addEventListener("hashchange", function () { if (location.hash === "#termin") open("visit"); });
    /* Okt. 2026: Beratungs-Knopf mobil weg, solange Kaufknopf oder Kasse-Knopf sichtbar ist (CSS: body.az-buy-inview) */
    var buyEls = document.querySelectorAll("#MainContent .product-form__submit, .az-csum__checkout");
    if (buyEls.length && "IntersectionObserver" in window) {
      var inView = [];
      var buyIo = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          var i = inView.indexOf(en.target);
          if (en.isIntersecting && i < 0) inView.push(en.target);
          if (!en.isIntersecting && i > -1) inView.splice(i, 1);
        });
        document.body.classList.toggle("az-buy-inview", inView.length > 0);
      });
      buyEls.forEach(function (el) { buyIo.observe(el); });
    }
  }

  /* ---------- Kollektions-Reihe: Pfeile + Fortschritt ---------- */
  function initRails() {
    document.querySelectorAll("[data-az-rail]").forEach(function (rail) {
      var sec = rail.closest("section");
      var prev = sec && sec.querySelector("[data-az-rail-prev]");
      var next = sec && sec.querySelector("[data-az-rail-next]");
      var bar = sec && sec.querySelector("[data-az-rail-bar]");
      function step() { var c = rail.querySelector(".az-model"); return c ? c.getBoundingClientRect().width + 20 : 320; }
      function update() {
        var max = rail.scrollWidth - rail.clientWidth;
        var ratio = rail.scrollWidth ? rail.clientWidth / rail.scrollWidth : 1;
        if (bar) {
          bar.style.width = Math.max(12, ratio * 100) + "%";
          bar.style.transform = "translateX(" + (max > 0 ? (rail.scrollLeft / max) * ((1 / Math.max(ratio, .01)) - 1) * 100 : 0) + "%)";
        }
        if (prev) prev.disabled = rail.scrollLeft <= 4;
        if (next) next.disabled = rail.scrollLeft >= max - 4;
        if (sec) sec.classList.toggle("is-static", max <= 4);
      }
      if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
      if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
      rail.addEventListener("scroll", update, { passive: true });
      window.addEventListener("resize", update);
      update();
    });
  }

  /* ---------- Grill-Finder ---------- */
  function initFinder() {
    document.querySelectorAll("[data-az-finder]").forEach(function (root) {
      var dataEl = root.querySelector("[data-az-finder-data]");
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var models = data.models || [];
      var S = data.strings || {};
      var steps = [].slice.call(root.querySelectorAll(".az-finder__step"));
      var result = root.querySelector("[data-az-finder-result]");
      var bar = root.querySelector("[data-az-finder-bar]");
      var ans = {};
      var history = [];

      function show(n) {
        steps.forEach(function (s) { s.classList.toggle("is-active", +s.getAttribute("data-step") === n); });
        result.hidden = n !== 0;
        if (bar) bar.style.width = (n === 0 ? 100 : n === 4 ? 92 : ((n - 1) / 3) * 100 + 4) + "%";
      }
      function fmt(str, n) { return (str || "").replace(/\{\{\s*count\s*\}\}/, n); }
      function priceText(m) { return m.varies ? (S.from || "{{ price }}").replace(/\{\{\s*price\s*\}\}/, m.price) : m.price; }

      function recommend() {
        var persons = ans.persons || 4, zones = ans.zones || 1;
        /* Aussenküche: nur Grills mit Einbauversion, Empfehlung zeigt direkt die Einbauversion */
        var src = models;
        if (ans.place === "kitchen") {
          var built = models.filter(function (m) { return m.bi; }).map(function (m) {
            return { title: m.bi.title, url: m.bi.url, img: m.bi.img || m.img, price: m.bi.price, varies: m.bi.varies,
                     max: m.max, persons: m.persons, zones: m.zones, table: false, builtin: true };
          });
          if (built.length) src = built;
        }
        var models_ = src;
        var tables = models_.filter(function (m) { return m.table; });
        var grills = models_.filter(function (m) { return !m.table; });
        if (ans.place === "table" && persons <= 4 && tables.length) {
          return { pick: tables[0], alt: grills[0] || null };
        }
        var pool = grills.length ? grills : models_;
        var same = pool.filter(function (m) { return m.zones === zones; });
        if (!same.length) same = pool;
        var pick = null;
        for (var i = 0; i < same.length; i++) { if (same[i].max >= persons) { pick = same[i]; break; } }
        if (!pick) {
          for (var j = 0; j < pool.length; j++) { if (pool[j].max >= persons) { pick = pool[j]; break; } }
        }
        if (!pick) pick = pool[pool.length - 1];
        var alt = null;
        var idx = same.indexOf(pick);
        if (idx > -1 && same[idx + 1]) alt = same[idx + 1];
        if (!alt) {
          for (var k = 0; k < pool.length; k++) {
            if (pool[k] !== pick && pool[k].max === pick.max) { alt = pool[k]; break; }
          }
        }
        if (!alt) {
          var bigger = pool.filter(function (m) { return m !== pick && m.max >= pick.max; });
          alt = bigger[0] || pool.filter(function (m) { return m !== pick; }).slice(-1)[0] || null;
        }
        return { pick: pick, alt: alt };
      }

      function render() {
        var r = recommend();
        var m = r.pick;
        if (!m) return;
        root.querySelectorAll('[data-r="link"]').forEach(function (a) { a.href = m.url; });
        var img = root.querySelector('[data-r="img"]');
        if (img) { img.src = m.img; img.alt = m.title; }
        root.querySelector('[data-r="name"]').textContent = m.title;
        var reasons = [];
        if (m.persons) reasons.push(fmt(S.persons, m.persons));
        if (m.table) reasons.push(S.table);
        else if (m.zones === 2) reasons.push(S.two);
        else reasons.push(S.one);
        if (!m.table && m.max >= 10) reasons.push(S.big);
        root.querySelector('[data-r="reasons"]').innerHTML = reasons.map(function (t) {
          var li = document.createElement("li"); li.textContent = t; return li.outerHTML;
        }).join("");
        root.querySelector('[data-r="price"]').textContent = priceText(m);
        root.querySelector('[data-r="builtin"]').hidden = ans.place !== "kitchen";
        var visit = root.querySelector('[data-r="visit"]');
        if (visit) visit.setAttribute("data-az-model", m.title);
        var altP = root.querySelector('[data-r="alt"]');
        var altA = root.querySelector('[data-r="alt-link"]');
        if (r.alt && altP && altA) { altA.href = r.alt.url; altA.textContent = r.alt.title + " · " + priceText(r.alt); altP.hidden = false; }
        else if (altP) altP.hidden = true;
        show(0);
        /* Nur scrollen, wenn das Ergebnis nicht ohnehin schon gut sichtbar ist — sonst springt die Seite. */
        if (window.innerWidth < 900) {
          var rt = result.getBoundingClientRect().top;
          if (rt < 0 || rt > window.innerHeight * 0.6) result.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }

      /* E-Mail-Schritt: Ergebnis erst nach Eingabe; Mail an info@azado.ch per fetch (scheitert still) */
      function utmString() {
        var out = [];
        try {
          var p = new URLSearchParams(location.search), keys = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid", "fbclid"];
          keys.forEach(function (k) { if (p.get(k)) out.push(k + "=" + p.get(k)); });
          if (out.length) sessionStorage.setItem("azUtm", out.join(" | "));
          else out = [sessionStorage.getItem("azUtm") || ""];
        } catch (err) {}
        return out.join(" | ");
      }
      function answersText() {
        var lines = [];
        steps.forEach(function (s) {
          if (s.getAttribute("data-step") === "4") return;
          var b = s.querySelector("button.is-picked"), lg = s.querySelector("legend");
          if (!b || !lg) return;
          var q = lg.cloneNode(true); var sm = q.querySelector("small"); if (sm) sm.remove();
          lines.push(q.textContent.trim() + " " + b.textContent.trim());
        });
        return lines.join("\n");
      }
      function setField(form, name, val) {
        var el = form.querySelector('[name="' + name + '"]');
        if (el) el.value = val;
      }
      function sendLead(email, first, news, pick) {
        try {
          var mail = root.querySelector("[data-az-finder-mail]");
          if (mail && window.fetch) {
            var link = location.origin + pick.url;
            setField(mail, "contact[email]", email);
            setField(mail, "contact[name]", first || email);
            setField(mail, "contact[Betreff]", "Grillfinder: " + pick.title + " \u2013 " + email);
            setField(mail, "contact[Empfohlener Grill]", pick.title + " " + link);
            setField(mail, "contact[Antworten]", answersText());
            setField(mail, "contact[Newsletter]", news ? "ja" : "nein");
            setField(mail, "contact[Seite]", location.href.split("#")[0]);
            setField(mail, "contact[UTM]", utmString());
            setField(mail, "contact[Zeit]", new Date().toLocaleString("de-CH", { timeZone: "Europe/Zurich" }));
            fetch(mail.getAttribute("action") || "/contact", { method: "POST", body: new FormData(mail), credentials: "same-origin" }).catch(function () {});
          }
          var nf = root.querySelector("[data-az-finder-news]");
          if (news && nf && window.fetch) {
            setField(nf, "contact[email]", email);
            fetch(nf.getAttribute("action") || "/contact#contact_form", { method: "POST", body: new FormData(nf), credentials: "same-origin" }).catch(function () {});
          }
        } catch (err) {}
      }
      var leadForm = root.querySelector("[data-az-finder-lead]");
      if (leadForm) leadForm.addEventListener("submit", function (e) {
        e.preventDefault();
        var email = (leadForm.elements.email.value || "").trim();
        var err = leadForm.querySelector("[data-az-finder-error]");
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
          if (err) err.hidden = false;
          leadForm.elements.email.focus();
          return;
        }
        if (err) err.hidden = true;
        var r = recommend();
        if (r.pick) {
          sendLead(email, (leadForm.elements.firstname.value || "").trim(), leadForm.elements.newsletter.checked, r.pick);
          try { if (window.azTrackLead) window.azTrackLead("Grillfinder"); } catch (e2) {}
        }
        render();
      });

      root.addEventListener("click", function (e) {
        var b = e.target.closest("button[data-q]");
        if (b) {
          var q = b.getAttribute("data-q"), v = b.getAttribute("data-v");
          ans[q] = q === "place" ? v : parseInt(v, 10);
          b.parentNode.querySelectorAll("button").forEach(function (x) { x.classList.toggle("is-picked", x === b); });
          var cur = +b.closest(".az-finder__step").getAttribute("data-step");
          history.push(cur);
          if (cur === 1) show(2);
          else if (cur === 2) { if (v === "table" && (ans.persons || 4) <= 4) { ans.zones = 1; show(4); } else show(3); }
          else show(4);
          return;
        }
        if (e.target.closest("[data-az-finder-back]")) { show(history.pop() || 1); return; }
        if (e.target.closest("[data-az-finder-restart]")) {
          ans = {}; history = [];
          root.querySelectorAll(".is-picked").forEach(function (x) { x.classList.remove("is-picked"); });
          show(1);
        }
      });
      show(1);
    });
  }

  function init() { initConcierge(); initRails(); initFinder(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
